export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1551801746-ce367c4c5d91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxncm91cCUyMGhpZ2glMjBzY2hvb2wlMjBzdHVkZW50cyUyMG91dGRvb3IlMjBsZWFybmluZyUyMGZpZWxkJTIwc3R1ZHklMjBhY2FkZW1pY3xlbnwwfHx8fDE3OTEyODc5MDh8MA&ixlib=rb-4.1.0&q=85",
  lifeSciences: "https://images.unsplash.com/photo-1707944746058-4da338d0f827?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMHNjaWVudGlmaWMlMjBmaWVsZCUyMHJlc2VhcmNoJTIwbGFib3JhdG9yeSUyMHN0dWR5JTIwYWNhZGVtaWN8ZW58MHx8fHwxNzkxMjgzNDI3fDA&ixlib=rb-4.1.0&q=85",
  engineering: "https://images.unsplash.com/photo-1742767069929-0c663150b164?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMHJvYm90aWNzJTIwZW5naW5lZXJpbmclMjB0ZWNobm9sb2d5JTIwbGFib3JhdG9yeSUyMHByb2plY3R8ZW58MHx8fHwxNzkxMjgzNDI3fDA&ixlib=rb-4.1.0&q=85",
  fieldEcology: "https://images.unsplash.com/photo-1758599667729-a6f0f8bd213b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxzdHVkZW50cyUyMGZpZWxkJTIwcmVzZWFyY2glMjBlY29sb2d5JTIwZW52aXJvbm1lbnRhbCUyMHN0dWR5JTIwbmF0dXJlJTIwb3V0ZG9vcnxlbnwwfHx8fDE3OTEyODM0MzR8MA&ixlib=rb-4.1.0&q=85",
  microscope: "https://images.unsplash.com/photo-1630959302878-a30de73cdbb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxzdHVkZW50cyUyMHNjaWVudGlmaWMlMjBmaWVsZCUyMHJlc2VhcmNoJTIwbGFib3JhdG9yeSUyMHN0dWR5JTIwYWNhZGVtaWN8ZW58MHx8fHwxNzkxMjgzNDI3fDA&ixlib=rb-4.1.0&q=85",
  robotics: "https://images.unsplash.com/photo-1562758778-e5638b5b6607?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxzdHVkZW50cyUyMHJvYm90aWNzJTIwZW5naW5lZXJpbmclMjB0ZWNobm9sb2d5JTIwbGFib3JhdG9yeSUyMHByb2plY3R8ZW58MHx8fHwxNzkxMjgzNDI3fDA&ixlib=rb-4.1.0&q=85",
  commerce: "https://images.unsplash.com/photo-1758270705518-b61b40527e76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1MTN8MHwxfHNlYXJjaHw0fHx1bml2ZXJzaXR5JTIwYnVzaW5lc3MlMjBzdHVkZW50cyUyMGNvbW1lcmNlJTIwZWNvbm9taWNzJTIwZmllbGQlMjBzdHVkeXxlbnwwfHx8fDE3OTEyODM6MTd8MA&ixlib=rb-4.1.0&q=85",
  humanities: "https://images.unsplash.com/photo-1784904338266-f5b736d00533?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1NTN8MHwxfHNlYXJjaHw0fHxzdHVkZW50cyUyMG11c2V1bSUyMGhpc3RvcnklMjBodW1hbml0aWVzJTIwY3VsdHVyYWwlMjBoZXJpdGFnZSUyMHN0dWR5fGVufDB8fHx8MTc5MTI4MzYxN3ww&ixlib=rb-4.1.0&q=85",
};

export const STATS = [
  { value: "45", label: "Countries & Regions" },
  { value: "29", label: "UNESCO Sites" },
  { value: "31", label: "Proposed Institutions" },
  { value: "126", label: "Reference Institutions" },
  { value: "3,400+", label: "Designated Field Learning Hours" },
  { value: "2,100+", label: "Planned CAS Hours" },
  { value: "220+", label: "Signature Experiences" },
  { value: "17/17", label: "SDGs Mapped" },
];

export const ARCHITECTURE = [
  {
    title: "CAS: Creativity, Activity, Service",
    text: "Every journey balances the three strands of our learning philosophy.",
  },
  {
    title: "ATL: Approaches to Learning",
    text: "Each field inquiry names the ATL skills a student will practice: research, communication, thinking, self-management and social.",
  },
  {
    title: "UN Sustainable Development Goals",
    text: "Every learning journey aligns to four to six of the 17 UN SDGs.",
  },
  {
    title: "Learning Evidence Methodology",
    text: "A five-stage evidence pipeline the school can defend to any audit body: Preparation, Field Inquiry, Reflection, Portfolio, Institutional Report.",
  },
];

export const STRANDS = [
  {
    letter: "C",
    title: "Curriculum",
    subtitle: "Anchored to inquiry",
    text: "A learning question is set. Subjects are mapped across IB, Cambridge, CBSE, and ICSE. The journey is a syllabus with weather in it.",
  },
  {
    letter: "A",
    title: "Action",
    subtitle: "In the field, with method",
    text: "Every day carries a field inquiry: a lab, a walk, a partnership visit, a build. Students carry protocols, not just cameras.",
  },
  {
    letter: "S",
    title: "Service",
    subtitle: "Reciprocal, not saviourist",
    text: "Journeys are co-designed with NGOs and community partners who set the terms. Students contribute skills, not charity.",
  },
  {
    letter: "I",
    title: "Immersion",
    subtitle: "Place, over posture",
    text: "Authentic presence in place, culture, and community. Students enter real-world environments as active participants, moving through a developmental continuum.",
  },
  {
    letter: "A",
    title: "Assessment",
    subtitle: "Measurable, portable",
    text: "Every journey produces a reflection journal, and a leadership rubric as per their grade level.",
  },
];

export const IB_PROGRAMS = [
  {
    code: "PYP",
    title: "Foundational Inquiry & Wonder",
    text: "Nurturing innate wonder and building an early understanding of sustainability, community, and human connection.",
  },
  {
    code: "MYP",
    title: "Interdisciplinary Exploration & Connection",
    text: "Cultivating critical thinking, personal identity, and structure inquiry during key formative years.",
  },
  {
    code: "DP",
    title: "Analytical Investigation & Academic Rigor",
    text: "Fostering academic independence, critical analysis, and defensible evidence creation aligned with CAS, internal Assessments, and future university readiness.",
  },
];

export const DOMAINS = [
  {
    name: "Life Sciences, Medicine & Health",
    image: IMAGES.lifeSciences,
    explore:
      "Cultivates curiosity and foundational inquiry into local biodiversity, ecosystem health, and human-environment interactions.",
    apply:
      "Deepens subject application through field data collection, ecological protocol execution, and investigation into health systems and medical research.",
  },
  {
    name: "Engineering, Technology & Applied Sciences",
    image: IMAGES.engineering,
    explore:
      "Introduces real-world mechanics, sustainable design principles, and observation of local technology and water management systems.",
    apply:
      "Focus on technical analysis, system design evaluation, resource management protocols, and field inquiry alongside practicing engineers and innovators.",
  },
  {
    name: "Commerce, Economics, Enterprise",
    image: IMAGES.commerce,
    explore:
      "Develops an understanding of trade, local enterprise models, consumer behaviour, and economic resource constraints.",
    apply:
      "Analyzes business viability, market forces, financial systems, sustainable supply chains, and founder-led social innovations.",
  },
  {
    name: "Humanities, Social Sciences & Creative Studies",
    image: IMAGES.humanities,
    explore:
      "Fosters historical empathy, cultural observation, artistic appreciation, and foundational social inquiry.",
    apply:
      "Conducts primary qualitative research, archival analysis, policy evaluation, and critical studies in sociology, governance, and creative arts.",
  },
];

export const SIX_LEVELS = [
  { level: "Level 1", title: "The Institution", body: "The Experiential Education Foundation" },
  { level: "Level 2", title: "Flagship Initiative", body: "CASIA, Centre for Applied Studies & Immersive Academics" },
  { level: "Level 3", title: "Co-design Partners", body: "Partner Schools, beside CASIA as co-design partners" },
  { level: "Level 4", title: "The Work", body: "Curriculum Journeys, co-designed, delivered, documented, evaluated" },
  { level: "Level 5", title: "People & Places", body: "Students • Faculty • Places • Communities" },
  { level: "Level 6", title: "The Outcome", body: "Learning Evidence, reports, portfolios, documentation" },
];

export const EVIDENCE_STUDENT = [
  { title: "Reflection Journal", text: "The discipline that converts an experience into portable learning." },
  { title: "Digital Field Portfolio", text: "Documented student inquiry, interviews, and primary data collected in the field." },
  { title: "Service & Leadership Records", text: "Tangible evidence of community engagement and collaborative problem-solving." },
  { title: "CAS Evidence", text: "Portfolio-ready materials mapped to IB core requirements where relevant." },
];

export const EVIDENCE_SCHOOL = [
  { title: "Curriculum-Mapping Report", text: "A formal record showing how field inquires directly addressed specific syllabus outcomes." },
  { title: "Institutional Learning Report", text: "High-level academic and impact documentation for school leadership and governance." },
  { title: "Faculty Observation Dossier", text: "Professional insights capturing student growth, capacity change, and learning dynamics." },
  { title: "Program Media Archive", text: "High-resolution documentation and media summary of the field inquiry." },
];

export const AREAS_OF_INTEREST = [
  "International Baccalaureate (PYP / MYP / DP)",
  "Life Sciences, Medicine & Health",
  "Engineering, Technology & Applied Sciences",
  "Commerce, Economics, Enterprise",
  "Humanities, Social Sciences & Creative Studies",
  "General / Multiple Domains",
];

export const CONTACT = {
  chennai: "+91 84282 55599",
  bangalore: "+91 90716 55599",
  email: "info@casia.education",
};
